import ReactGA from 'react-ga4'

export const GAPageViewTrack = ({ location, prevLocation }) => {
  ReactGA.initialize(process.env.GATSBY_GA_MEASUREMENT_ID)

  const {pathname} = location
  const prePathname = prevLocation?.pathname

  if (pathname !== prePathname) {
    ReactGA.send({ hitType: "pageview", page: pathname })
  }
}